export default `

             █████████
            ██       ██
            ██       ██
            ██       
         ██████████████████
         █               ██
         █    ██   ██    ██
         █               ██
         █               ██
         █    ███████    ██
         █               ██
         ██████████████████
`